/**
 * Общие для всех страниц скрипты
 */
import("./main");

/**
 * Загрузка раскрывающихся меню в сайдбаре
 */
import("./components/schoolSideLoader").then((_) => {});

/**
 * Управление показом tooltip
 */
$(document).on(
    "mouseenter focus mouseleave blur",
    ".camp__info-icon, [data-title][data-tooltip], [data-title]:not(.daterangepicker [data-title])",
    function (e) {
        import("./components/handleTooltip").then((module) => {
            module.default($(this), e);
        });
    }
);

/**
 * Раскрытие программ школ в каталоге
 */
$(document).on("click", ".program__all", function (e) {
    e.preventDefault();

    import("./components/showAllSchoolPrograms").then((module) => {
        module.default($(this));
    });
});

window.onload = () => {
    // Для хороших показателей lcp, после загрузки страницы возвращаем opacity первой большой картинке свайпера
    setTimeout(() => {
        $("#firstSwiperItem").css("opacity", "1");
    }, 2000);

    // Базовые настройки IntersectionObserver
    const options = {
        // Родитель целевого элемента
        root: null,
        // Отступ
        rootMargin: "0px",
        // Процент пересечения целевого элемента
        threshold: 0.1,
    };

    // Определяем наблюдателя
    const observer = new IntersectionObserver((entries, observer) => {
        // Для каждого входимого элемента
        entries.forEach((entry) => {
            // Если элемент появился на экране в зоне видимости
            if (entry.isIntersecting) {
                const classList = entry.target.classList;

                // Для галереи
                if (classList.contains("school__gallery")) {
                    import("./components/showGallery").then((module) => {});
                    import("./components/schoolGallery").then((module) => {});
                }

                // Для комментариев
                if (classList.contains("review")) {
                    import("./components/newComments");
                }

                // Для школьной карты
                if (
                    classList.contains("school-map") ||
                    classList.contains("school__map")
                ) {
                    import("./components/schoolMap");
                }

                if (classList.contains("calc-app")) {
                    import("./components/programCalculatorLoader").then(
                        (module) => {
                            module.default("desktop");
                            console.log(
                                "desktop education program calculator loaded"
                            );
                        }
                    );
                }

                if (classList.contains("show-calc")) {
                    import("./components/programCalculatorLoader").then(
                        (module) => {
                            module.default("mobile");
                            console.log(
                                "mobile education program calculator loaded"
                            );
                        }
                    );
                }
            }
        });
    }, options);

    // Определяем наблюдаемые элементы
    const observedItems = document.querySelectorAll(
        ".school__gallery, .subscription, .review, .school-map, .school__map, .calc-app, .show-calc"
    );

    // К каждому наблюдаемому элементу
    observedItems.forEach((form) => {
        // подключаем IntersectionObserver
        observer.observe(form);
    });
};
